module.exports = __webpack_public_path__ + "staticcomp/img/cover.96fe9ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/11/cover.jpg
// module id = clg1
// module chunks = 39